// extracted by mini-css-extract-plugin
module.exports = {"documentTitle":"DocumentPreview_documentTitle__3v-oF","documentHeader":"DocumentPreview_documentHeader__3m5jO"};